import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux'

// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Box, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { setAdminUserStateAction } from "../../../appRedux/actions/adminUser";
import Iconify from '../../../components/iconify';
import { setUserTokenInLocal, setUserEssentials, getUserAccessToken } from '../../../utils/storage'
import EnvironmentSwitcher from '../../../components/EnvironmentSwitcher';
// api
import { loginUserWithEmailAndPassword } from '../../../api/auth'
import { getCommonData } from '../../../api/commonAPIs';
import { setAccountStateAction } from '../../../appRedux/actions/account';
import handIcon from '../../../assets/rms/icon/hand.svg'
// ----------------------------------------------------------------------
const { REACT_APP_RESTAURANT_ID } = process.env;

export default function LoginForm({ setSnackbarMessage, setSnackbarOpen }) {
  const { user } = useParams()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [inputs, setInputs] = useState({ restaurantId: '' })
  const [isLoading, setIsLoading] = useState(false)

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)

    try {
      const { data } = await loginUserWithEmailAndPassword({ ...inputs, restaurantId: REACT_APP_RESTAURANT_ID });
      
      if (data.success) {
        // Store user data and token
        const userStateData = {
          "firstName": data.data.firstName,
          "lastName": data.data.lastName,
          "email": data.data.email,
          "role": data.data.role,
          "isSuperAdmin": data.data.isSuperAdmin
        }
        setUserEssentials(userStateData);
        setUserTokenInLocal(data.data.token);

        // Get common data using stored token
        const result = await getCommonData();
        
        // Update Redux state
        dispatch(setAdminUserStateAction({
          user: userStateData,
          token: getUserAccessToken(),
          isAuthenticated: true,
          commonData: result.data.data.commondata
        }))

        dispatch(setAccountStateAction({
          restaurant: { _id: inputs.restaurantId }
        }))

        navigate('/dashboard', { replace: true })
      } else {
        setSnackbarMessage({ msg: data.message, success: false })
        setSnackbarOpen(true)
      }
    } catch (error) {
      setSnackbarMessage({ msg: error.message, success: false })
      setSnackbarOpen(true)
      console.log("err ", error);
    } finally {
      setIsLoading(false)
    }
  };

  return (
    <Stack component='form' onSubmit={handleSubmit} spacing={2}>
      <Box sx={{ backgroundColor: { xs: '#000', sm: 'inherit' }, borderRadius: 2 }}>
        <Stack spacing={2} sx={{ p: { xs: 2, sm: 0 } }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="h3" mr={1}>
              Hi, Admin!
            </Typography>
            <img src={handIcon} alt='ico' />
          </Box>
          <EnvironmentSwitcher />
          <TextField
            required
            name="email"
            label="Email"
            onChange={handleChange}
            sx={{ backgroundColor: { xs: '#fff' }, borderRadius: 2, }}
          />
          <TextField
            required
            name="password"
            label="Password"
            type={showPassword ? 'text' : 'password'}
            onChange={handleChange}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
            sx={{ backgroundColor: '#fff', borderRadius: 2, }}
          />
        </Stack>
      </Box>
      <Link variant="subtitle2" underline="hover" href={user === 'superadmin' ? `/forget-password/${user}` : '/forget-password'} sx={{ cursor: 'pointer', alignSelf: 'flex-end' }}>
        Forgot password?
      </Link>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <LoadingButton sx={{ borderRadius: 2, width: 250, backgroundColor: '#E0E082', color: '#000' }} loading={isLoading} size="large" type="submit" variant="contained">
          Login
        </LoadingButton>
      </Box>
    </Stack>
  );
}
